module.exports = __webpack_public_path__ + "img/v4Success.4447aba4.png";